import type { StateTree } from '@makemydeal/dr-dash-types';
import { DealMode } from '../types/dealModeEnum';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { getIsContractingContext } from './contractingSelectors';
import { isOnSaveValidationFlow } from './saveValidationSelectors';
import * as quoteSelectors from './quoteSelectors';

export const getCurrentDealMode = (state: StateTree) => state.dealMode.currentDealMode;
export const isFnIDealMode = (state: StateTree) => state.dealMode?.currentDealMode === DealMode.fiMode;

/**
 * Returns true when optional desking fields should behave as non-required.
 * Conditions: the deal screen experience is Deal Central
 * (including Deal Central with F&I and MV Lite) AND NOT in Contracting mode AND we are NOT in F&I mode.
 */
export const isOptionalDeskingMode = (state: StateTree): boolean =>
    isOptionalDeskingValidationEnabled(state) && !getIsContractingContext(state) && !isOnSaveValidationFlow(state);

/**
 * Returns true when optional desking validation should be performed.
 * Like isOptionalDeskingMode but also returns true in Contracting and Save modes.
 *
 * Quote Mode always qualifies: a quote has no shopper, so its validation guard must stay on.
 */
export const isOptionalDeskingValidationEnabled = (state: StateTree): boolean =>
    quoteSelectors.getQuoteMode(state) || (dealerSelectors.isDealCentralExperience(state) && !isFnIDealMode(state));
